import React, { Component } from "react";
import { Button, Icon, Input, Modal, Switch, Tooltip } from "antd";
import PartyInfo from "./PartyInfo";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode } from "@fortawesome/free-solid-svg-icons";
import { urlPath } from "./Settings";
import { getAuthHeader } from "../utils/security";
import { copyToClipboard, highlightMaterial } from "./Helpers";

library.add(faCode);

const { TextArea } = Input;

class PartyTagModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            visible: false,
            urlArray: [],
            switchChecked: false,
        };
    }

    /*shouldComponentUpdate(){
    if(!this.props.updatePartyModal)
      return false
    return true
  }*/

    componentWillReceiveProps() {
        const comp = this;
        if (!this.state.visible)
            this.setState({
                urlArray: [],
                pixeltrackerValue: this.props.pixeltracker,
                descriptionValue: this.props.description,
                userurlValue: this.props.userurl,
                userurls: this.props.userurls,
                sgCodeValue:
                    this.props.sgcode && this.props.sgcode !== 0
                        ? this.props.sgcode
                        : "",
                sgCodeFilled:
                    this.props.sgcode.toString().length > 0 &&
                    this.props.sgcode !== 0,
            });
    }

    copyToClipboard = (e) => {
        const input = e.target
            .closest("#partytagTextarea")
            .querySelectorAll("textarea")[0];
        if (!input.value || input.value.length === 0)
            input.value = input.getAttribute("placeholder");
        input.select();
        document.execCommand("copy");
        //Message('Copied' , 'info');
    };
    copyUrlToClipboard = (e) => {
        const input = e.target
            .closest(".ant-input-group-wrapper")
            .querySelectorAll("input")[0];
        if (!input.value || input.value.length === 0) input.value = "N/A";
        input.select();
        document.execCommand("copy");
    };
    handleCancel = (id) => {
      
        this.props.saveFields()
        this.setState({ visible: false });
        document.getElementById("partytagIinput." + id).value = "";
        this.props.updateBooking(this.props.materialSpecificationId, true);
    };
    handleOk = () => {
        this.props.saveFields()
        console.log("<=== Clicked Submit ===>");
        this.setState({ newPartyTag: false });
        const partyTagInput = document.getElementById(
            "partytagIinput." + this.props.id
        );
        const partyButton = document.getElementById(
            "partyButton." + this.props.id
        );
        const partyTagInputUrl = document.getElementById(
            "partyTagInputUrl." + this.props.id
        );
        if (
            this.state.partyTagInitialCode !== this.state.partyTagCode &&
            partyTagInputUrl
        ) {
            partyTagInputUrl.value = "";
        }
        const partyTagInputDescription = document.getElementById(
            "partyTagInputDescription." + this.props.id
        );
        const validPartyTagUrl = document.getElementById(
            "validPartyTagUrl" + this.props.id
        );

        this.setState({ visible: false }, () => {
            console.log(this.props);
            console.log(this.state);

            let descriptionOnly = false;
            let sgCode = false;
            if (!this.props.internal) partyButton.classList.add("d-none");
            let value = null;
            //console.log(partyTagInput.value.length);
            if (partyTagInput && partyTagInput.value.length > 0) {
                value = partyTagInput.value;
                this.setState({ visible: false });
            } else if (
                this.state.sgCodeFilled &&
                this.props.loadConfig["web.uploadadmaterial.sgcode"]
            ) {
                value = this.state.sgCodeValue;
                this.setState({ visible: false });
                sgCode = true;
            } else if (partyTagInputUrl && partyTagInputUrl.value.length > 0) {
                value = partyTagInputUrl.value;
                this.setState({ visible: false });
                this.props.updateBooking(
                    this.props.materialSpecificationId,
                    true
                );
                return;
            } else if (
                partyTagInputDescription &&
                partyTagInputDescription.value.length > 0
            ) {
                value = partyTagInputDescription.value;
                this.setState({ visible: false });
                descriptionOnly = true;
            } else {
                const target = validPartyTagUrl;
                target && target.classList.remove("d-none");
                target && target.classList.add("error-msg");
                this.props.updateBooking(
                    this.props.materialSpecificationId,
                    true
                );
                return;
            }
            this.props.handlePartyTag(
                this.fillUrlField(value),
                this.props.materialSpecificationId,
                this.props.id,
                descriptionOnly,
                sgCode,
                this.state.descriptionValue,
                this.state.pixeltrackerValue,
                this.state.userurlValue
            );
            if (partyTagInput) partyTagInput.value = "";
        });
    };

    getPartyTag = () => {
        if (this.props.id > 0)
            fetch(
                urlPath +
                    "/api/loadadmaterial-3party?admaterial=" +
                    this.props.id +
                    "&timezone=" +
                    Intl.DateTimeFormat().resolvedOptions().timeZone,
                { credentials: "include", headers: getAuthHeader() }
            )
                .then((response) => {
                    if (response.ok) {
                        return response.text();
                    } else {
                        this.setState({ partyTagCode: "" });
                    }
                })
                .then((data) => {
                    if (data)
                        this.setState({
                            partyTagCode: data,
                            partyTagFilled: data.length > 0,
                        });
                })
                .catch((e) => console.error("Cannot load partytag!", e));
    };

    admaterialUpdate = (e, admaterial, field, value) => {
        const target = e.target;
        const targetValid = "field-valid";
        const targetInvalid = "field-invalid";
        if (field === "userurl") {
            if (!this.checkValidUrl(value, admaterial)) {
                target.classList.add(targetInvalid);
                target.classList.remove(targetValid);
                return;
            } else {
                this.getFields();
                return;
            }
        }
        if (!admaterial || admaterial < 1)
            console.error("Wrong AdMaterial." + admaterial);
        else
            fetch(
                urlPath +
                    "/api/admaterialupdate?admaterial=" +
                    admaterial +
                    "&" +
                    field +
                    "=" +
                    encodeURIComponent(value),
                {
                    method: "PUT",
                    credentials: "include",
                    headers: getAuthHeader(),
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    console.log(
                        "AdMaterial." + admaterial + " update:",
                        field + "=" + value,
                        data
                    );
                    target.classList.add(targetValid);
                })
                .catch((e) => console.error("Cannot update material", e));
    };
    getFields = () => {
        const urlFields = document
            .getElementById("urlsContainer." + this.props.id)
            .querySelectorAll(".saveUrlInput");
        const urlExistingFields = document
            .getElementById("urlsExistingContainer." + this.props.id)
            .querySelectorAll(".saveUrlInput");
        const firstUrl = document.getElementById(
            "partyTagInputUrl." + this.props.id
        ).value;
        let urlsToSave = "&userurl=" + encodeURIComponent(firstUrl);
        if (urlFields && urlFields.length > 0) {
            for (let i = 0; i < urlFields.length; i++) {
                if (urlFields[i].value.length > 0)
                    urlsToSave +=
                        "&userurl=" + encodeURIComponent(urlFields[i].value);
            }
            for (let i = 0; i < urlExistingFields.length; i++) {
                if (urlExistingFields[i].value.length > 0)
                    urlsToSave +=
                        "&userurl=" +
                        encodeURIComponent(urlExistingFields[i].value);
            }
        }
        console.log(urlsToSave);
        if (!this.props.id || this.props.id < 1)
            console.error("Wrong AdMaterial." + this.props.id);
        else
            fetch(
                urlPath +
                    "/api/admaterialupdate?admaterial=" +
                    this.props.id +
                    urlsToSave,
                {
                    method: "PUT",
                    credentials: "include",
                    headers: getAuthHeader(),
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    document
                        .getElementById("partyTagInputUrl." + this.props.id)
                        .classList.add("field-valid");
                    for (let i = 0; i < urlFields.length; i++) {
                        urlFields[i].classList.add("field-valid");
                    }
                })
                .catch((e) => console.error("Cannot update material", e));
    };
    checkValidUrl = (url, admaterial) => {
        const pattern = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
        const target = document.getElementById("validPartyTagUrl" + admaterial);
        if (!target) return true;
        if (!pattern.test(url) && url !== "") {
            target.classList.remove("d-none");
            target.classList.add("error-msg");
            console.log("Please enter a valid URL.");
            return false;
        } else {
            target.classList.add("d-none");
            target.classList.remove("error-msg");
            return true;
        }
    };
    deleteUrl = (e) => {
        const id = e.target.closest(".url-container").id;
        const urlContainerId = document.getElementById(id);
        //urlContainerId.remove();
        urlContainerId.querySelectorAll(".newUrlInput")[0].value = "";
        //urlContainerId.classList.add('d-none');
        //urlContainerId.querySelectorAll('.newUrlInput')[0].classList.add('d-none');
        this.getFields();
    };
    addUrlField = (e) => {
        console.log("Adding new url");
        const urlArray = this.state.urlArray;
        const id = Math.floor(Math.random() * 1000000);
        urlArray.push(
            <span id={"urlContainerId." + id} className="url-container">
                <Input
                    id={id}
                    className="ant-input partyTag-input newUrlInput saveUrlInput"
                    placeholder={this.props.translations.placeUrl}
                    onChange={(e) =>
                        this.admaterialUpdate(e, id, "userurl", e.target.value)
                    }
                    addonAfter={
                        <span>
                            {this.props.internal && (
                                <Icon
                                    className="copy-url-button"
                                    type="copy"
                                    onClick={this.copyUrlToClipboard}
                                />
                            )}
                            <Icon
                                onClick={(e) => this.deleteUrl(e)}
                                className="delete-url"
                                type="delete"
                            />
                        </span>
                    }
                />
                <span className="d-none" id={"validPartyTagUrl" + id}>
                    {this.props.translations.invalidUrl}
                </span>
            </span>
        );
        this.setState({
            urlArray: urlArray,
        });
    };

    loadMaterial = () => {
        if (this.props.id > 0)
            fetch(
                urlPath +
                    "/api/loadadmaterial?admaterial=" +
                    this.props.id +
                    "&timezone=" +
                    Intl.DateTimeFormat().resolvedOptions().timeZone,
                {
                    credentials: "include",
                    headers: getAuthHeader(),
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        pixeltrackerValue: data.pixeltracker,
                        descriptionValue: data.description,
                        userurlValue: data.userurls[0],
                        userurls: data.userurls,
                        sgCodeValue:
                            data.sgcode &&
                            !isNaN(data.sgcode) &&
                            data.sgcode !== 0
                                ? data.sgcode
                                : "",
                        sgCodeFilled:
                            data.sgcode.toString().length > 0 &&
                            !isNaN(data.sgcode) &&
                            data.sgcode !== 0,
                    });
                })
                .catch((e) => {
                    console.error("Cannot load material!");
                });
    };
    removeLists = () => {
        this.setState({ urlArray: [] });
        //if(document.getElementById('urlsExistingContainer.' + this.props.id))
        //  document.getElementById('urlsExistingContainer.' + this.props.id).innerHTML = '';
    };
    openPartyTag = (id) => {
        highlightMaterial(id);
        this.removeLists();
        //this.loadMaterial();
        if (
            this.props.inputfilename &&
            this.props.inputfilename.startsWith("thirdpartytag_")
        )
            this.getPartyTag();
        this.setState({ visible: true });
    };
    togglePartyTag = (checked) => {
        console.log(checked);
        this.setState({ switchChecked: checked });
        /* const partyTagInput = document.getElementById("partytagIinput." + this.props.id);
        if(checked){
            partyTagInput.classList.remove('d-none')
        }else{
            partyTagInput.classList.add('d-none')
        }*/
    };

    fillUrlField = (value) => {
        if (!value.startsWith("http")) {
            if (value.startsWith("www.") || value.endsWith(".com"))
                value = "http://" + value;
        }
        return value;
    };
    fieldChange = (e, field, partyTagInitialCode) => {
        console.log("partyTagInitialCode", partyTagInitialCode);
        this.setState({ partyTagInitialCode });
        let value = e.target.value;
        value = this.fillUrlField(value);
        //console.log(field, value, value.length);
        if (field === "partytag") {
            this.setState({
                newPartyTag: true,
                partyTagCode: value,
                partyTagFilled: value.length > 0,
            });
        }
        if (field === "sgcode") {
            this.setState({
                newPartyTag: true,
                sgCodeValue: value,
                sgCodeFilled: value.length > 0 && !isNaN(value),
                sgErrorField: isNaN(value),
            });
        }
    };

    render() {
        const {
            inputfilename,
            userurls,
            description,
            pixeltracker,
            sgCode,
        } = this.props;
        const partyModalHasContent =
            (inputfilename &&
                (inputfilename.startsWith("thirdpartytag_") ||
                    inputfilename.startsWith("vpaid_") ||
                    inputfilename.startsWith("vast_") ||
                    RegExp(/index.html/gm).test(inputfilename))) ||
            (userurls && userurls.length > 0) ||
            (description && description.length) > 0 ||
            (pixeltracker && pixeltracker.length > 0) ||
            (sgCode && sgCode.length > 0);
        return (
            <div className="dropzone-partytag-container">
                <Tooltip
                    placement="right"
                    title={this.props.translations.partyTagTooltip}
                >
                    <Button
                        id={"partyButton." + this.props.id}
                        size="small"
                        type="default"
                        onClick={() => this.openPartyTag(this.props.id)}
                        className={partyModalHasContent ? "green" : ""}
                    >
                        <span className="partytag-dropzone-text">
                            {this.props.translations.partyTagSmallDropzoneLabel}
                        </span>
                        <FontAwesomeIcon
                            className={
                                partyModalHasContent
                                    ? "partytag-dropzone-icon green"
                                    : "partytag-dropzone-icon"
                            }
                            icon="code"
                        />
                    </Button>
                </Tooltip>
                <Modal
                    title={this.props.translations.partyTagTitle}
                    className="partyTag-modal"
                    closable={false}
                    width={720}
                    visible={this.state.visible}
                    footer={[
                        <Button
                            data-translationkey="close"
                            className="capitalize"
                            key="back"
                            onClick={() => this.handleCancel(this.props.id)}
                        >
                            {this.props.translations.close}
                        </Button>,
                        <Button
                            disabled={
                                this.state.sgErrorField ||
                                !this.state.newPartyTag ||
                                (!this.state.sgCodeFilled &&
                                    !this.state.partyTagFilled)
                            }
                            data-translationkey="get"
                            className="capitalize"
                            id="submitPreflight"
                            onClick={this.handleOk}
                            key="submit"
                            type="primary"
                        >
                            {this.props.translations.submit}
                        </Button>,
                    ]}
                >
                    {this.props.loadConfig[
                        "web.upload3rdpartytag.showswitch"
                    ] && (
                        <div className="partytag-control">
                            <span data-translationkey="additionalInfo">
                                {this.props.translations.additionalInfo}
                            </span>
                            <Switch
                                data-translationkey="yes no"
                                defaultChecked={false}
                                onClick={(checked, ev) => {
                                    this.togglePartyTag(checked);
                                }}
                                size="small"
                                checkedChildren={this.props.translations.yes}
                                unCheckedChildren={this.props.translations.no}
                            />
                        </div>
                    )}
                    {/* <== Should be moved to the partyinfo */}
                    {false && (
                        <div id="partytagTextarea">
                            <TextArea
                                placeholder={`1 => ${
                                    this.props.translations.partyTag
                                }`}
                                id={"partytagIinput." + this.props.id}
                                rows={6}
                                value={this.state.partyTagCode}
                                onChange={(e) =>
                                    this.fieldChange(e, "partytag")
                                }
                                disabled={this.state.sgCodeFilled}
                            />
                            {this.props.internal && (
                                <Button
                                    style={{ float: "right", margin: "5px 0" }}
                                    onClick={(e) => this.copyToClipboard(e)}
                                    size="small"
                                    type="primary"
                                >
                                    <Icon type="copy" />
                                </Button>
                            )}
                        </div>
                    )}
                    {/* Should be moved to the partyinfo ==>*/}
                    {this.props.loadConfig["web.uploadadmaterial.sgcode"] && (
                        <div>
                            <Input
                                id={"sgCodeInput." + this.props.id}
                                addonBefore={this.props.translations.sgCode}
                                className="partyTag-input"
                                placeholder={this.props.translations.sgCode}
                                value={this.state.sgCodeValue}
                                disabled={this.state.partyTagFilled}
                                onChange={(e) => this.fieldChange(e, "sgcode")}
                                addonAfter={
                                    <Icon
                                        className="pointer blue"
                                        type="copy"
                                        onClick={(e) => copyToClipboard(e)}
                                    />
                                }
                            />
                            <span
                                className={
                                    this.state.sgErrorField
                                        ? "sgErrorMessage"
                                        : "d-none"
                                }
                            >
                                {this.props.translations.sgError}
                            </span>
                        </div>
                    )}
                    {(this.props.loadConfig[
                        "web.upload3rdpartytag.showextrafields"
                    ] ||
                        this.state.switchChecked) &&
                        this.state.visible && (
                            <div>
                                <PartyInfo
                                    loadConfig={this.props.loadConfig}
                                    showPartytagTextarea={true}
                                    partyTagUpdateOnChange={this.fieldChange}
                                    showSGCode={false}
                                    id={this.props.id}
                                    specId={this.props.materialSpecificationId}
                                    translations={this.props.translations}
                                    internal={this.props.internal}
                                />
                            </div>
                        )}
                </Modal>
            </div>
        );
    }
}

export default PartyTagModal;



// WEBPACK FOOTER //
// ./src/components/PartyTagModal.js